const firebaseConfig = {
  apiKey: "AIzaSyBOtIPhc-IiWr5VzdGofzSsc8btRnXIG78",
  authDomain: "to-europa.firebaseapp.com",
  projectId: "to-europa",
  storageBucket: "to-europa.appspot.com",
  messagingSenderId: "107530781740",
  appId: "1:107530781740:web:6c83cbfc3ff403a6b0fd89",
  measurementId: "G-PFBPGSK0K7"
  };

export default firebaseConfig;